"use strict";
/* eslint-disable import/prefer-default-export */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLP = exports.getUserDeshareBalance = void 0;
var ethers_1 = require("ethers");
var contracts_1 = require("../contracts");
var parseBigInt_1 = __importDefault(require("../utils/parseBigInt"));
var strategy_1 = require("./strategy");
var types_1 = require("../types");
var calculateGasMargin_1 = __importDefault(require("../types/calculateGasMargin"));
var formatBigInt_1 = __importDefault(require("../utils/formatBigInt"));
function getUserDeshareBalance(accountAddress, strategyAddress, jsonProvider, raw) {
    return __awaiter(this, void 0, void 0, function () {
        var strategyContract, shares;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    strategyContract = (0, contracts_1.getERC20Contract)(strategyAddress, jsonProvider);
                    return [4 /*yield*/, strategyContract.balanceOf(accountAddress)];
                case 1:
                    shares = _a.sent();
                    return [2 /*return*/, raw ? shares : (0, formatBigInt_1.default)(shares, 18)];
            }
        });
    });
}
exports.getUserDeshareBalance = getUserDeshareBalance;
function removeLP(accountAddress, shares, strategyAddress, jsonProvider, overrides, _amount0Min, _amount1Min) {
    var _a;
    if (_amount0Min === void 0) { _amount0Min = '0'; }
    if (_amount1Min === void 0) { _amount1Min = '0'; }
    return __awaiter(this, void 0, void 0, function () {
        var chainId, signer, strategyContract, strategy, params, gasLimit, _b, _c;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    chainId = jsonProvider.network.chainId;
                    if (!Object.values(types_1.SupportedChainId).includes(chainId)) {
                        throw new Error("Unsupported chainId: ".concat(chainId !== null && chainId !== void 0 ? chainId : 'undefined'));
                    }
                    signer = jsonProvider.getSigner(accountAddress);
                    strategyContract = (0, contracts_1.getStrategyContract)(strategyAddress, signer);
                    return [4 /*yield*/, (0, strategy_1.getStrategyInfo)(chainId, strategyAddress)];
                case 1:
                    strategy = _e.sent();
                    if (!strategy)
                        throw new Error("Strategy not found [".concat(chainId, ", ").concat(strategyAddress, "]"));
                    params = [
                        shares instanceof ethers_1.BigNumber ? shares : (0, parseBigInt_1.default)(shares, 18),
                        (0, parseBigInt_1.default)(_amount0Min, +strategy.token0.decimals),
                        (0, parseBigInt_1.default)(_amount1Min, +strategy.token1.decimals),
                    ];
                    if (!((_a = overrides === null || overrides === void 0 ? void 0 : overrides.gasLimit) !== null && _a !== void 0)) return [3 /*break*/, 2];
                    _b = _a;
                    return [3 /*break*/, 4];
                case 2:
                    _c = calculateGasMargin_1.default;
                    return [4 /*yield*/, (_d = strategyContract.estimateGas).burn.apply(_d, params)];
                case 3:
                    _b = _c.apply(void 0, [_e.sent()]);
                    _e.label = 4;
                case 4:
                    gasLimit = _b;
                    params[3] = __assign(__assign({}, overrides), { gasLimit: gasLimit });
                    return [2 /*return*/, strategyContract.burn.apply(strategyContract, params)];
            }
        });
    });
}
exports.removeLP = removeLP;
//# sourceMappingURL=remove.js.map